exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn.btn-primary {\n    /*background-color: #7885a6;\n    border-color: #7885a6;\n    padding: 0px .875rem 0;\n    height: 2rem;*/\n}\n.input-group>.form-control {\n    height: 2rem;\n}\n.oveacademyfilters a {\n    display: block;\n}\n", ""]);

// exports
